var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('span',{staticClass:"sam-input-error"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }